

        function createMapCrossair(mapboxMap) {
            mapboxMap.getCanvas().style.cursor = 'crosshair';
            mapboxMap.on('movestart', () => (mapboxMap.getCanvas().style.cursor = 'grab'));
            mapboxMap.on('moveend', () => (mapboxMap.getCanvas().style.cursor = 'crosshair'));
        }

        const container = document.getElementById('map_container');
        const params = location.search.split(/[?&]/).map(function(e) {
            if (e.length) {
                return e.split('=');
            }
            return [];
        }).filter(function(e) {
            return (e && e.length === 2);
        });
        const options = {
            maxzoom: 24,
            introcard: { active: false }
        };
        params.forEach(function(item) {
            options[item[0]] = item[1];
        });

        if (!options.emmid) {
            location.href = location.href
                + (location.href.indexOf('?') > -1 ? '&' : '?')
                + 'emmid=' + prompt('emmid');
        }

        const livemap = window.wemap.v1.createLivemap(container, options, false);
        await livemap.waitForReady();
        const privateInterface = await new Promise(resolve => window.wemap.v1.getPrivateInterface(resolve));
        const map = privateInterface.getFacade().getApplication().map._driver._map;

        createMapCrossair(map);

        map.on('click', e => {
            const description = '<strong>Coordinates</strong><br />' + e.lngLat.lat.toFixed(8) + ', ' + e.lngLat.lng.toFixed(8);

            navigator.clipboard.writeText(e.lngLat.lat.toFixed(8) + ', ' + e.lngLat.lng.toFixed(8));

            new window.mapboxgl.Popup()
                .setLngLat(e.lngLat)
                .setHTML(description)
                .addTo(map);
        });

    